import { io, type Socket } from 'socket.io-client'
import { getToken } from '~/utils/api'

let socket: Socket | null = null

const ensureSocket = (): Socket => {
  if (!socket) {
    const url = import.meta.env.VITE_BACKEND_API_ENDPOINT || 'http://localhost:3333'
    socket = io(url, {
      // Le namespace racine est désormais authentifié (même jeton bearer que `/operations`) : la
      // connexion ne peut donc plus partir avant que le jeton ne soit lu (cf. `connectSocket`).
      autoConnect: false,
      forceNew: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10_000,
      rememberUpgrade: true,
      timeout: 60_000,
      transports: ['websocket', 'polling'],
      upgrade: true,
    })

    socket.on('connect_error', (error) => {
      console.error('❌ [WebSocket] Connection error:', error)
    })

    socket.on('reconnect_error', (error) => {
      console.error('❌ [WebSocket] Reconnection failed:', error)
    })
  }
  return socket
}

/**
 * Connecte le socket de notifications avec le jeton de la session.
 *
 * Le serveur n'accepte plus un socket anonyme et n'inscrit chaque session qu'aux rooms de son
 * périmètre (boutiques de ses affectations, par famille de notification) : le client n'a donc
 * aucun abonnement à demander, il ne reçoit que ce qui le concerne.
 */
export const connectSocket = async (): Promise<void> => {
  const current = ensureSocket()
  const token = await getToken()
  if (!token) return

  current.auth = { token }
  if (!current.connected && !current.active) current.connect()
}

export const getSocket = (): Socket => {
  const current = ensureSocket()
  void connectSocket()
  return current
}
